import { Message } from 'element-ui';

// 排序
export const sortList = list => {
    return list.sort((a, b) => a.rowIndex - b.rowIndex);
};

/**
 * @description 格式化装、卸货列表数据
 * @param {Array} list 列表数据
 */
export const formatList = list => {
    list.forEach((v, i) => {
        v.originReservationTime = v.reservationTime;
        v.bookingDate = '';
        v.radio = -1;
        v.rowIndex = i;
        v.loading = false;
        v.radioList = [];
        v.lineInfo = {};
        v.abilityTimeCodesCurrent = [];
        v.overFlag = '';
    });
    return list;
};

/**
 * @description 校验提交参数
 * @param {Array} list 选中的列表数据
 */
export const validateSubmitParams = list => {
    if (!list.length) {
        Message.warning('未选择数据，不能确定');
        return false;
    }
    for (const v of list) {
        if (!v.reservationTime || v.radio === -1) {
            Message.warning(`【${v.whName}】未选择预约时间段，不能确定`);
            return false;
        }
        if (!isValidateAppoint(v)) {
            return false;
        };
    }
    return true;
};

/**
 * @description 处理dataList参数
 * @param {Array} list 选中的列表数据
 */
const dealWithDataList = list => {
    var params = [];
    list.forEach(v => {
        params.push({
            reservationDateStr: v.reservationTime ? v.reservationTime.split(' ')[0] : '', // 预约日期
            abilityInfo: v.radioList.length > 0 ? v.radioList[v.radio] : {},
            whInfo: {
                beReservation: v.beReservation, // 是否需要预约
                reservationTime: v.reservationTime, // 预约时间
                totalVolume: v.totalVolume, // 方量
                totalWeight: v.totalWeight, // 重量
                whCode: v.whCode, // 仓库编码
                whName: v.whName // 仓库名称
            }
        });
    });
    return params;
};

/**
 * @description 处理确定提交参数
 * @param {Array} list 选中的列表数据
 */
export const dealWithSubmitParams = (list, rowData) => {
    return {
        dispatchNo: rowData.dispatchNo, // 发车单号
        driver: rowData.driver, // 司机名称
        driverContactWay: rowData.driverContactWay, // 司机联系方式
        vehicleCard: rowData.vehicleCard, // 车牌号
        dataList: dealWithDataList(list)
    };
};

/**
 * @description 园区预约/改约前进行卡控
 */
export const isValidateAppoint = (row) => {
    const newOriginReservationTime = new Date(row.originReservationTime).getTime();
    const newReservationTime = new Date(row.reservationTime).getTime();
    if (row.totalVolume > row.radioList[row.radio].totalQty - row.radioList[row.radio].totalQtyBooking) {
        Message.warning(`【${row.whName}】请联系仓库更改可预约方量或者预约其他时段`);
        return false;
    }
    // TK单在WMS已备货
    if (row.originReservationTime && +row.wmsStatus > 300) {
        Message.warning(`【${row.whName}】已开始生产作业，不支持装货改约`);
        return false;
    }
    if (newOriginReservationTime === newReservationTime) {
        Message.warning(`【${row.whName}】请重新选择预约时间段`);
        return false;
    }
    return true;
};

/**
 * @description 处理取消预约提交参数
 * @param {Array} list 选中的列表数据
 * @param {Object} rowData 组件行数据
 * @param {String} activeName 当前标签页
 */
export const dealWithCancelParams = (list, rowData, activeName) => {
    var params = [];
    list.forEach(v => {
        params.push({
            dispatchNo: rowData.dispatchNo,
            whCode: v.whCode,
            abilityType: activeName === 'load' ? 0 : 10 // 装货|卸货【0：装货, 10: 卸货】
        });
    });
    return params;
};

/**
 * @description 校验取消预约
 * @param {Array} list 选中的列表数据
 */
export const validateConfirmParams = (list) => {
    if (!list.length) {
        Message.warning('未选择数据，不能取消预约');
        return false;
    }
    for (const v of list) {
        if (!v.originReservationTime) {
            Message.warning(`【${v.whName}】未预约时间段，不能取消预约`);
            return false;
        }
    };
    return true;
};
